/* eslint max-classes-per-file: 0 */

import { MunMeh as Data, MunMehCollection as Collection } from '@/typings/api/MunMeh'

import { Fabric } from '@/store/createCrudModule'
import { LkRegMehAdapter } from './LkRegMehAdapter'


export const fabric = Fabric<Data, Collection>()

type S = LkRegMehState
type G = LkRegMehGetters
type M = LkRegMehMutations
type A = LkRegMehActions

export class LkRegMehState extends fabric.State {}

export class LkRegMehGetters extends fabric.Getters<S> {}

export class LkRegMehMutations extends fabric.Mutations<S> {}

export class LkRegMehActions extends fabric.Actions<S, G, M, A> {
    protected readonly adapter = new LkRegMehAdapter();

    protected readonly idName = 'id';
}
